var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnimalRightImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 126,
    viewBox: "0 0 257 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.902 80.0505C141.382 78.9905 138.512 64.7205 138.512 64.7205C127.902 76.5105 111.712 59.6005 111.712 59.6005C111.712 59.6005 110.492 81.4105 127.902 80.0505Z",
    fill: "#96F2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6019 101.17L97.2319 107.75C97.2319 107.75 92.1219 109.76 91.7419 112.58C91.3619 115.4 100.572 116.94 104.812 112.64C109.052 108.34 108.752 100.59 108.752 100.59C108.752 100.59 103.712 89.8605 97.6019 101.17Z",
    fill: "#96F2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7805 73.0704C72.9605 93.2104 56.7104 105.33 56.7104 105.33C57.4404 115.29 52.4505 116.59 49.1305 118.86C45.8105 121.12 35.9405 120.13 37.3705 114.92C38.8005 109.71 44.2005 113.06 41.2905 107.95C38.3905 102.84 35.0205 104.02 35.0205 104.02C37.6305 105.59 35.9504 114.24 33.9704 116.34C32.0004 118.44 21.7905 118.96 21.4205 114.83C21.0505 110.7 25.3304 107.17 25.6004 105.33C25.8804 103.5 16.4504 92.9604 16.4504 92.9604C-1.84959 74.0404 5.21042 57.7704 5.21042 57.7704C4.10042 43.5004 9.91049 35.4304 9.91049 35.4304C9.91049 35.4304 -5.3395 9.31039 4.4205 4.86039C14.1805 0.41039 21.6705 15.4604 21.6705 15.4604L37.6104 15.5604C37.6104 15.5604 47.7104 1.07039 53.6104 3.42039C59.5104 5.77039 57.9705 26.3704 52.2505 29.0404C52.2505 29.0404 56.2504 39.5204 54.3404 45.6404C54.3404 45.6404 55.8805 54.6204 76.5605 54.3704C76.5605 54.3704 91.1404 49.2804 100.08 51.7004C109.02 54.1204 114.19 63.0304 114.19 63.0304C114.19 63.0304 130.7 74.9104 127.52 89.8604C124.34 104.81 121.17 100.03 120.99 103.01C120.88 104.83 122.75 108 124.23 110.19C125.26 111.72 124.82 113.79 123.25 114.77C120.98 116.19 117.61 117.38 114.45 114.93C109.01 110.71 118.451 109.24 112.551 102.9C109.271 99.3704 103.55 99.6404 97.5704 101.18C92.8104 102.41 87.8805 104.44 83.8705 106C74.8305 109.53 57.7304 109.57 57.7304 109.57C57.7304 109.57 40.1105 106.25 47.6305 100.61",
    fill: "#38D9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7805 73.0704C72.9605 93.2104 56.7104 105.33 56.7104 105.33C57.4404 115.29 52.4505 116.59 49.1305 118.86C45.8105 121.12 35.9405 120.13 37.3705 114.92C38.8005 109.71 44.2005 113.06 41.2905 107.95C38.3905 102.84 35.0205 104.02 35.0205 104.02C37.6305 105.59 35.9504 114.24 33.9704 116.34C32.0004 118.44 21.7905 118.96 21.4205 114.83C21.0505 110.7 25.3304 107.17 25.6004 105.33C25.8804 103.5 16.4504 92.9604 16.4504 92.9604C-1.84959 74.0404 5.21042 57.7704 5.21042 57.7704C4.10042 43.5004 9.91049 35.4304 9.91049 35.4304C9.91049 35.4304 -5.3395 9.31039 4.4205 4.86039C14.1805 0.41039 21.6705 15.4604 21.6705 15.4604L37.6104 15.5604C37.6104 15.5604 47.7104 1.07039 53.6104 3.42039C59.5104 5.77039 57.9705 26.3704 52.2505 29.0404C52.2505 29.0404 56.2504 39.5204 54.3404 45.6404C54.3404 45.6404 55.8805 54.6204 76.5605 54.3704C76.5605 54.3704 91.1404 49.2804 100.08 51.7004C109.02 54.1204 114.19 63.0304 114.19 63.0304C114.19 63.0304 130.7 74.9104 127.52 89.8604C124.34 104.81 121.17 100.03 120.99 103.01C120.88 104.83 122.75 108 124.23 110.19C125.26 111.72 124.82 113.79 123.25 114.77C120.98 116.19 117.61 117.38 114.45 114.93C109.01 110.71 118.451 109.24 112.551 102.9C109.271 99.3704 103.55 99.6404 97.5704 101.18C92.8104 102.41 87.8805 104.44 83.8705 106C74.8305 109.53 57.7304 109.57 57.7304 109.57C57.7304 109.57 40.1105 106.25 47.6305 100.61",
    stroke: "#38D9A9",
    strokeWidth: 1.2521,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.57 28.2705C56.4 33.4205 54.34 39.8605 56.9701 46.7405C57.9501 49.3105 60.99 50.5505 62.46 52.8705C63.63 54.7305 66.5101 62.3005 64.8101 69.0605C58.9301 92.4505 38.48 94.0905 34.97 94.3105C25.13 94.9505 9.3901 89.7505 4.2701 57.3905C4.0401 55.9605 4.00005 43.6205 9.47005 34.7705C10.15 33.6705 4.66007 46.1205 21.3701 48.6305C22.1701 48.7505 30.11 52.2605 30.57 52.3905C33.33 53.1605 37.4701 47.2505 40.3101 46.9705C61.4301 44.8705 52.23 27.8105 52.57 28.2705Z",
    fill: "#96F2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.662 42.3205C39.902 40.1405 29.4919 36.7305 29.4919 36.7305L20.6119 40.3605C14.7219 42.3205 23.2319 53.0105 23.2319 53.0105H34.5019C39.5119 48.0005 41.342 44.2705 40.662 42.3205Z",
    fill: "#0CA678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5918 30.5305C33.5918 30.5305 35.7818 24.6405 39.9918 30.5305C39.9918 30.5305 38.3118 35.2505 33.5918 30.5305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9904 30.2705C24.9904 30.2705 22.9103 25.2905 18.8203 30.2705C18.8203 30.2705 21.1104 34.7205 24.9904 30.2705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7611 30.1504C22.6911 34.0904 20.6211 39.9604 20.6211 42.3204C20.6211 44.6804 20.6211 49.3904 28.8711 45.8604C28.8711 45.8604 38.3011 50.9104 38.3011 42.3204C38.3011 35.2504 33.5811 36.4304 32.4111 29.3504C31.7011 25.1004 36.3811 14.8204 36.3811 14.8204C33.8811 14.8204 27.6211 14.8204 25.1111 14.8204C25.1211 14.8204 29.7111 27.2904 26.7611 30.1504Z",
    fill: "#C3FAE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8014 31.9705C22.5967 31.9705 23.2413 31.3257 23.2413 30.5305C23.2413 29.7352 22.5967 29.0905 21.8014 29.0905C21.0061 29.0905 20.3613 29.7352 20.3613 30.5305C20.3613 31.3257 21.0061 31.9705 21.8014 31.9705Z",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1315 31.9705C37.9268 31.9705 38.5714 31.3257 38.5714 30.5305C38.5714 29.7352 37.9268 29.0905 37.1315 29.0905C36.3362 29.0905 35.6914 29.7352 35.6914 30.5305C35.6914 31.3257 36.3362 31.9705 37.1315 31.9705Z",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7014 47.3305C24.7014 47.3305 19.4414 61.1805 28.8814 61.1805C38.3214 61.1805 33.6014 48.1005 33.6014 48.1005L28.8814 46.1205L24.7014 47.3305Z",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7918 113.28C41.7918 113.28 37.2217 115.29 40.7117 119.48",
    stroke: "#12B886",
    strokeWidth: 1.2521,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5616 114.23C46.5616 114.23 43.0216 117.12 46.5616 119.8",
    stroke: "#12B886",
    strokeWidth: 1.2521,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3408 111.88C25.3408 111.88 22.3208 112.85 23.2408 117.08",
    stroke: "#12B886",
    strokeWidth: 1.2521,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4608 111.88C29.4608 111.88 24.6209 114.51 28.5109 117.91",
    stroke: "#12B886",
    strokeWidth: 1.2521,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7617 114.23C92.7617 114.23 94.8918 110.69 98.4318 110.69",
    stroke: "#12B886",
    strokeWidth: 1.2521,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9912 114.89C98.9912 114.89 98.3612 111.87 101.341 110.7",
    stroke: "#12B886",
    strokeWidth: 1.2521,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6915 37.6105C27.6915 37.6105 24.9016 37.3005 24.1516 38.7905C21.7916 43.5105 28.8715 44.6805 28.8715 44.6805C28.8715 44.6805 32.4116 43.9005 32.4116 38.7905C32.4116 37.6105 27.6915 37.6105 27.6915 37.6105Z",
    fill: "#099268",
    stroke: "#099268",
    strokeWidth: 1.2521,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.041 55.0605C28.041 55.0605 29.421 53.8205 28.241 46.7505",
    stroke: "#099268",
    strokeWidth: 1.2521,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2713 5.22045C47.2713 5.22045 41.8514 12.8505 43.0314 16.3905C44.2114 19.9305 48.9214 16.3905 48.9214 16.3905L47.7413 21.1105L50.1013 18.7505L48.9214 24.6404C48.9214 24.6404 57.1714 22.2805 57.1714 11.6705C57.1714 11.6705 57.4713 4.29045 52.5913 3.16045C48.9113 2.30045 47.2713 5.22045 47.2713 5.22045Z",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.71094 22.3105C6.84094 30.5905 11.1909 24.6405 11.1909 24.6405L6.47095 16.3905L14.721 21.1105L13.541 18.7505C13.541 18.7505 17.081 19.9305 18.031 15.4105C18.981 10.8905 11.741 4.8505 11.741 4.8505C11.741 4.8505 5.39096 1.7005 2.10096 7.0105C-1.17904 12.3205 3.71094 22.3105 3.71094 22.3105Z",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.791 24.6404C36.791 24.6404 40.551 24.1204 41.791 27.9104",
    stroke: "#0CA678",
    strokeWidth: 1.2521,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6809 24.0305C23.6809 24.0305 19.1709 23.9305 18.1309 27.2305",
    stroke: "#0CA678",
    strokeWidth: 1.2521,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.83 110.7C116.83 110.7 113.36 112.87 115.92 115.32",
    stroke: "#12B886",
    strokeWidth: 1.2521,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.961 110.7C119.961 110.7 122.101 110.84 122.051 114.89",
    stroke: "#12B886",
    strokeWidth: 1.2521,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.991 101.871C224.695 101.871 230.941 99.8964 230.941 97.4608C230.941 95.0252 224.695 93.0508 216.991 93.0508C209.287 93.0508 203.041 95.0252 203.041 97.4608C203.041 99.8964 209.287 101.871 216.991 101.871Z",
    fill: "#099268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.261 98.9308C217.511 88.9408 211.631 69.1908 210.481 65.4608C210.461 65.3908 210.371 65.4308 210.371 65.4908C210.691 68.0008 211.731 77.1508 210.381 81.3008",
    fill: "#0CA678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.262 97.8608C221.262 97.8608 233.702 53.6108 242.002 49.4708L222.642 99.2508",
    fill: "#38D9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.731 99.2407C214.351 77.1207 196.371 56.3807 196.371 56.3807C196.371 56.3807 212.961 84.0307 212.961 99.2407",
    fill: "#38D9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.112 97.8607C218.492 96.4807 214.342 67.4407 214.062 56.3807C213.782 45.3207 217.112 34.2607 217.112 34.2607C217.112 34.2607 222.642 53.6507 221.262 68.8507C219.882 84.0507 219.242 99.2507 219.242 99.2507",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.661 98.9308C220.661 98.9308 230.941 53.6208 231.631 47.8108C232.321 42.0008 231.631 33.5508 231.631 33.5508C231.631 33.5508 221.961 65.2608 219.191 98.9408",
    fill: "#0CA678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.94 97.4608C230.94 97.4608 226.71 99.8208 217.76 100.221C208.81 100.621 203.04 97.4608 203.04 97.4608C203.04 97.4608 201.9 119.981 206.94 123.331C210.13 125.451 214.45 126.001 218.07 126.001C223.39 126.001 228.18 122.531 229.51 117.381C229.52 117.331 229.54 117.271 229.55 117.221C230.94 111.681 230.94 97.4608 230.94 97.4608Z",
    fill: "#20C997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.25 56.4707C253.25 56.4707 257.91 63.2207 255.24 69.3107C252.57 75.4007 247.25 75.9607 247.25 75.9607",
    stroke: "#12B886",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.371 41.3699L247.391 34.4199L243.861 42.2099L252.371 41.3699Z",
    fill: "#63E6BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.351 106.869C245.571 106.869 246.561 105.88 246.561 104.659C246.561 103.439 245.571 102.449 244.351 102.449C243.13 102.449 242.141 103.439 242.141 104.659C242.141 105.88 243.13 106.869 244.351 106.869Z",
    stroke: "#12B886",
    strokeWidth: 1.1157,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.392 3.23047L222.902 13.5005",
    stroke: "#12B886",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.671 13.2695L218.891 24.4295",
    stroke: "#12B886",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.812 121.87L235.312 111.74",
    stroke: "#12B886",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.365 7.47556L100.922 4.95117L98.3975 11.3944L104.841 13.9188L107.365 7.47556Z",
    fill: "#63E6BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.511 1L117.361 19.97",
    stroke: "#12B886",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.171 1.11914L124.861 14.4991",
    stroke: "#12B886",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.492 52.3007C135.492 52.3007 133.802 35.9707 114.502 35.0807",
    stroke: "#12B886",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.601 33.5707L114.801 35.1507L116.381 36.9507L114.941 36.8507L113.361 35.0507L115.171 33.4707L116.601 33.5707Z",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.511 54.0197L183.451 75.3797",
    stroke: "#12B886",
    strokeWidth: 1.1789,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.76 40.8197C167.01 40.2197 167.18 39.5297 166.93 38.9297C166.73 38.4597 166.3 38.1297 165.85 37.8997C163.97 36.9697 161.71 37.5997 159.79 38.4397C159.16 38.7097 158.53 39.0197 158.02 39.4697C157.5 39.9197 157.11 40.5497 157.07 41.2297C157.02 42.0997 157.56 42.9297 158.27 43.4497C158.98 43.9697 159.83 44.2397 160.67 44.4997C161.6 44.7897 162.73 45.1497 163.68 44.7497C163.59 44.6797 163.48 44.4897 163.38 44.3997C164.85 43.5497 166.08 42.4297 166.76 40.8197Z",
    fill: "#38D9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.05 50.2496C193.05 50.2496 186.87 40.7996 177.79 44.8296C168.72 48.8596 181.68 55.6996 190.52 53.4596C199.37 51.2196 193.05 50.2496 193.05 50.2496Z",
    fill: "#099268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.221 12.5097C152.281 15.9897 155.271 18.4497 157.511 21.3097C159.251 23.5297 160.591 26.0797 161.431 28.7697C162.271 22.4897 161.921 15.6597 158.271 10.4797C157.281 9.07969 156.091 7.83969 154.891 6.60969C153.701 5.37969 152.031 3.11969 151.171 5.71969C150.511 7.75969 150.601 10.4997 151.221 12.5097Z",
    fill: "#38D9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.721 21.9296C156.531 24.6396 159.651 27.0196 162.221 29.9596C161.661 29.3196 161.461 27.6296 161.171 26.8096C160.761 25.6696 160.331 24.5496 159.851 23.4396C158.901 21.2596 157.781 19.1396 156.361 17.2296C154.111 14.1796 151.601 11.5996 147.451 12.3096C147.891 15.9596 151.201 19.4896 153.721 21.9296Z",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.471 30.2097C161.651 28.6897 163.681 28.0397 165.601 28.0697C167.521 28.0997 169.381 28.7297 171.201 29.3497C170.071 30.7397 168.391 31.5497 166.771 32.3197C165.421 32.9597 163.221 34.6097 161.651 34.3097C159.671 33.9297 159.311 31.5997 160.471 30.2097Z",
    fill: "#38D9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.741 53.9797C172.831 52.9997 174.061 52.1897 175.141 51.1897C179.101 47.5197 180.351 41.7297 180.321 36.3297C177.461 38.2197 174.851 40.4797 172.321 42.7997C170.501 44.4697 168.661 46.2697 167.831 48.5897C167.001 50.9197 167.531 53.9097 169.651 55.1797",
    fill: "#38D9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.171 63.0197C165.171 63.0197 157.521 64.2797 156.641 60.6897C156.641 60.6897 150.491 58.7097 153.121 50.2497C155.751 41.7897 165.171 54.0097 165.171 54.0097C165.171 54.0097 166.341 58.3197 165.171 63.0197Z",
    fill: "#38D9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.311 71.2196C167.311 71.2196 163.501 62.8496 157.861 62.9296C152.221 63.0096 146.221 66.2297 146.221 66.2297C146.221 66.2297 160.001 72.3596 167.311 71.2196Z",
    fill: "#38D9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.64 80.7497C170.64 80.7497 167.19 67.7497 162.65 68.3197C158.11 68.8897 157.38 73.2097 157.38 73.2097C157.38 73.2097 155.03 74.6897 155.98 77.0997C156.93 79.4997 165.89 79.4697 165.89 79.4697L170.64 80.7497Z",
    fill: "#38D9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.25 84.2297C172.25 84.2297 180.06 78.9297 183.23 79.8097C186.4 80.6897 186.17 86.7597 186.17 86.7597C186.17 86.7597 177.96 83.3497 172.25 84.2297Z",
    fill: "#38D9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.86 78.9897C172.86 78.9897 174.931 78.0097 178.411 74.5297C178.851 74.0897 179.281 73.7397 179.671 73.4697C180.231 73.0897 179.981 72.2097 179.311 72.1397L176.38 71.8197C176.38 71.8197 175.82 69.0197 172.86 70.7297C169.9 72.4397 172.86 78.9897 172.86 78.9897Z",
    fill: "#38D9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.461 77.3698C167.461 77.3698 160.181 76.4497 157.381 84.4597C157.381 84.4597 165.491 84.3497 170.641 80.7497C175.791 77.1497 167.461 77.3698 167.461 77.3698Z",
    fill: "#0CA678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.84 81.5597C178.84 81.5597 177.07 73.2697 181.73 73.4397C186.39 73.6197 183.64 77.8797 183.64 77.8797C183.64 77.8797 188.72 78.4597 186.97 80.7497C185.22 83.0497 178.84 81.5597 178.84 81.5597Z",
    fill: "#099268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.041 58.2897C184.041 58.2897 189.841 54.0297 192.831 54.3897C195.831 54.7497 200.661 52.3597 200.601 48.2497C200.541 44.1397 189.501 49.2497 189.501 49.2497C189.501 49.2497 184.061 52.3497 184.041 58.2897Z",
    fill: "#38D9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.41 19.0497C178.41 19.0497 169.92 16.6797 168.14 20.3897C166.36 24.0997 163.34 31.7497 163.34 31.7497C163.34 31.7497 174.22 32.3397 176.19 27.0397C178.15 21.7497 178.41 19.0497 178.41 19.0497Z",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.561 18.2997C188.561 18.2997 192.66 17.0197 194.25 18.7897C195.83 20.5597 195.94 25.0697 195.94 25.0697L191.45 26.1797L188.561 18.2997Z",
    fill: "#099268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.82 90.1198C162.82 90.1198 161.96 103.67 165.62 113.52C166.56 116.04 168.72 117.91 171.34 118.53C173.78 119.1 177.04 119.59 180.32 119.23C184.47 118.78 187.93 115.86 189.08 111.85C189.87 109.11 190.62 105.4 190.62 101.19C190.62 92.3098 190.29 88.4897 190.29 88.4897C190.29 88.4897 188.92 91.4798 175.89 91.4798C162.86 91.4798 162.82 90.1198 162.82 90.1198Z",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.38 92.4797C184.195 92.4797 190.531 90.8947 190.531 88.9397C190.531 86.9846 184.195 85.3997 176.38 85.3997C168.566 85.3997 162.23 86.9846 162.23 88.9397C162.23 90.8947 168.566 92.4797 176.38 92.4797Z",
    fill: "#099268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.721 22.0697C189.711 12.8797 183.961 13.4997 183.961 13.4997C183.961 13.4997 181.741 19.0497 185.071 25.7097",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.541 36.8097C159.541 36.8097 160.651 29.0397 150.661 24.5997C140.671 20.1597 136.23 26.8197 136.23 26.8197C136.23 26.8197 156.211 35.6997 159.541 36.8097Z",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.98 54.5697C163.98 54.5697 161.76 46.7997 155.1 43.4697C148.44 40.1397 140.67 45.6897 140.67 45.6897L163.98 54.5697Z",
    fill: "#0CA678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.371 45.9097C143.371 45.9097 155.781 46.4597 165.771 55.3397",
    stroke: "#12B886",
    strokeWidth: 1.1789,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.82 24.0997C162.82 24.0997 170.63 24.5997 173.96 17.9397C177.29 11.2797 173.96 7.85974 173.96 7.85974C173.96 7.85974 167.3 8.71974 163.97 13.8897C160.64 19.0597 160.64 22.3897 162.86 24.6097",
    fill: "#38D9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.51 35.6997C189.51 35.6997 195.06 34.5897 198.39 27.9297C201.72 21.2697 194.6 23.0697 194.6 23.0697C194.6 23.0697 187.29 20.1597 185.07 25.7097C182.85 31.2597 189.51 35.6997 189.51 35.6997Z",
    fill: "#38D9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.83 25.7097C192.83 25.7097 187.28 40.1397 186.17 44.5797",
    stroke: "#12B886",
    strokeWidth: 1.1789,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.201 54.5697L168.391 50.5497L180.821 39.0297C180.821 39.0297 171.691 40.1497 168.391 44.0297C165.091 47.9097 167.311 51.2397 167.311 51.2397",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.501 91.3996L170.641 77.8796",
    stroke: "#12B886",
    strokeWidth: 1.1789,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.541 86.5796L169.501 87.3296C169.501 87.3296 159.541 95.6296 153.991 97.8496C153.991 97.8496 150.561 91.1396 159.541 86.4296C162.031 85.1196 165.991 85.3296 168.421 86.7496",
    fill: "#0CA678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.1 95.6397C156.21 94.5297 161.64 86.6397 171.67 87.1697",
    stroke: "#12B886",
    strokeWidth: 1.1789,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.18 86.7596C186.18 86.7596 181.74 81.2096 172.86 82.3196C172.86 82.3196 172.4 83.4296 172.07 84.5396",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.54 71.2597L159.44 70.3597C157.77 70.1697 156.12 69.8097 154.53 69.2797L146.32 66.5397C146.32 66.5397 154.71 65.6697 158.79 66.7797C162.87 67.8897 167.54 71.2597 167.54 71.2597Z",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.201 54.5697C166.201 54.5697 170.641 72.3297 170.641 77.8797",
    stroke: "#12B886",
    strokeWidth: 1.1789,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.791 67.7197C175.791 67.7197 175.641 67.3597 191.451 67.0697C191.451 67.0697 190.331 61.0497 182.711 61.7397C176.191 62.3397 175.791 67.7197 175.791 67.7197Z",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.19 73.4397C176.19 73.4397 172.4 75.4797 172.07 82.7897",
    stroke: "#12B886",
    strokeWidth: 1.1789,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.221 78.3297C187.991 78.6797 190.611 83.4297 193.241 84.6397C195.861 85.8497 198.591 84.6397 198.591 84.6397C198.591 84.6397 200.051 80.4497 194.221 77.4997C188.391 74.5497 185.241 78.1197 185.241 78.1197",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.611 64.5596H203.932C203.932 64.5596 199.491 60.1196 193.941 60.1196C188.391 60.1196 187.941 62.3396 187.941 62.3396",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.531 68.9996L171.771 65.8996C171.771 65.8996 180.751 56.7896 182.351 56.7896C183.961 56.7896 184.611 56.5196 184.611 56.5196C184.611 56.5196 180.621 52.3496 176.181 55.6796C171.741 59.0096 169.701 62.3396 170.161 67.3296",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.1 54.3896L169.31 69.4896",
    stroke: "#12B886",
    strokeWidth: 1.1789,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.161 44.5797L168.131 58.8797",
    stroke: "#12B886",
    strokeWidth: 1.1789,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.74 47.0897C178.74 47.0897 180.57 46.6997 189.35 49.4497",
    stroke: "#12B886",
    strokeWidth: 1.1789,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.281 43.3297C193.281 43.3297 198.661 35.0797 208.651 40.3197C208.651 40.3197 212.131 45.0297 205.951 46.9597C199.771 48.8897 197.551 47.2397 197.551 47.2397",
    fill: "#20C997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.311 43.5497C202.311 43.5497 194.691 42.3197 185.811 44.7297",
    stroke: "#12B886",
    strokeWidth: 1.1789,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.4 42.9597C186.4 42.9597 188.6 39.4297 190.72 37.5697C192.66 35.8597 196.02 32.8597 203.21 35.1297C204.67 35.5897 206.19 35.8397 207.71 35.7697L209.11 35.6997C209.11 35.6997 204.94 39.5497 199.44 40.3997",
    fill: "#0CA678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.99 42.3797C186.99 42.3797 197.78 36.2997 204.19 36.5597",
    stroke: "#12B886",
    strokeWidth: 1.1789,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.43 7.85974C153.43 7.85974 159.77 14.2097 161.32 27.7297",
    stroke: "#12B886",
    strokeWidth: 1.1789,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.98 37.9197L163.34 34.7997",
    stroke: "#12B886",
    strokeWidth: 1.1789,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.4 42.9597C186.4 42.9597 186.95 33.1797 183.23 30.5497C179.52 27.9197 171.07 26.4497 171.07 26.4497L174.9 28.9997C174.91 29.0097 184.54 36.6897 186.4 42.9597Z",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.46 85.5697L178.84 91.3997",
    stroke: "#12B886",
    strokeWidth: 1.1789,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.131 58.8597L183.451 67.1297",
    stroke: "#12B886",
    strokeWidth: 1.1789,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.201 55.6797L164.541 49.1397C163.801 46.2097 162.741 43.3697 161.391 40.6697L158.711 35.2997",
    stroke: "#12B886",
    strokeWidth: 1.1789,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.43 56.0297C165.43 56.0297 166.27 60.1897 165.68 62.9297",
    stroke: "#12B886",
    strokeWidth: 1.1789,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.831 13.6597C167.211 16.9697 165.601 20.2797 163.981 23.5897C163.071 25.4497 162.151 27.3397 161.691 29.3597",
    stroke: "#12B886",
    strokeWidth: 1.1789,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.281 70.2197C166.191 70.1797 166.971 70.8297 167.641 71.4397C168.671 72.3797 169.731 73.3596 170.301 74.6296",
    stroke: "#12B886",
    strokeWidth: 1.1789,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimalRightImage);
export default __webpack_public_path__ + "static/media/animalRightImage.48b7fec8002ae2cb70817056d9227930.svg";
export { ForwardRef as ReactComponent };